import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useModal } from '../modal';
import { apiFetch } from '../../../utils';

import { isValidName } from '../../../utils';

import { getOutfitNames } from '../../../utils/outfitnames';

import './index.css';

const outfitServer = process.env.REACT_APP_OUTFIT_SERVER || 'https://ameriax.org/image_server/animoutfit.php';
const outfits = await getOutfitNames();

const lookTypeMap = [
    {'1': 138, '2': 136, '3': 137, '4': 139},
    {'1': 130, '2': 128, '3': 129, '4': 131}
];

const CreateCharacterModal = () => {
    const { closeModal } = useModal();

    const sessionUser = useSelector(state => state?.session?.user);

    const [name, setName] = useState('');
    const [sex, setSex] = useState(0);
    const [vocation, setVocation] = useState(1);
    const [looktype, setLookType] = useState(lookTypeMap[sex][vocation]);
    const [lookhead, setHead] = useState(0);
    const [tmpHead, setTmpHead] = useState(false);
    const [headPalette, setHeadPalette] = useState(false);
    const [lookbody, setBody] = useState(0);
    const [tmpBody, setTmpBody] = useState(false);
    const [bodyPalette, setBodyPalette] = useState(false);
    const [looklegs, setLegs] = useState(0);
    const [tmpLegs, setTmpLegs] = useState(false);
    const [legsPalette, setLegsPalette] = useState(false);
    const [lookfeet, setFeet] = useState(0);
    const [tmpFeet, setTmpFeet] = useState(false);
    const [feetPalette, setFeetPalette] = useState(false);
    const [direction, setDirection] = useState(3);
    const [outfit, setOutfit] = useState(`${outfitServer}?id=${looktype}&addons=0&head=${lookhead}&body=${lookbody}&legs=${looklegs}&feet=${lookfeet}&direction=${direction}`);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setOutfit(`${outfitServer}?id=${looktype}&addons=0&
                  head=${tmpHead !== false ? tmpHead : lookhead}&
                  body=${tmpBody !== false ? tmpBody : lookbody}&
                  legs=${tmpLegs !== false ? tmpLegs : looklegs}&
                  feet=${tmpFeet !== false ? tmpFeet : lookfeet}&
                  direction=${direction}`);
    }, [sex, looktype, vocation, lookhead, tmpHead, lookbody, tmpBody, looklegs, tmpLegs, lookfeet, tmpFeet, direction]);

    useEffect(() => {
        if (sessionUser === null) {
            closeModal();
        }
    }, [sessionUser, closeModal]);

    const paletteColors = [];
    for (let i = 0; i < 133; i++) paletteColors.push(i);

    const validate = () => {
        const newErrors = {};
        if (!isValidName(name)) newErrors.name = ['Name can only be two words.', 'Name words must start with a capital letter.', 'Name words can only include lowercase after first.'];
        if (!newErrors.name) {
            const nameSplit = name.split(" ");
            for (const split of nameSplit) {
                if (split.length < 4 || split.length > 10) {
                    newErrors.name = ['Each word in name must be (4-10) characters.'];
                    break;
                };
            };
        } else {
            const nameSplit = name.split(" ");
            for (const split of nameSplit) {
                if (split.length < 4 || split.length > 10) {
                    newErrors.name.push('Each word in name must be (4-10) characters.');
                    break;
                };
            };
        }
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return;
        }

        const response = await apiFetch('/user/create_character', 'POST', {
            accountid: sessionUser.id, name, sex, vocation, looktype, lookhead, lookbody, looklegs, lookfeet,
        });
        if (!response || response.code !== 'success') {
            setLoading(false);
            setErrors(response.data);
            return;
        };
        
        setLoading(false);
        alert('Character Created! See you in game.');
        closeModal();
        return;
    };

    const buttonDisabled = name.length < 4 || loading;
    const vocationNames = ['Sorcerer', 'Druid', 'Paladin', 'Knight'];

    const handleButtonDown = (e) => {
    if (e.key !== 'Enter' && e.key !== 'Tab') return;
        e.preventDefault();
        
    const form = e.target.form;
    const index = [...form].indexOf(e.target);
    const nextIndex = index + 1;
    if (index === 1) {
        if (buttonDisabled) return;
        return handleSubmit(e);
    };
    const nextFocus = form[nextIndex];
    nextFocus.focus();
}

    const closePalettes = () => {
        setHeadPalette(false);
        setBodyPalette(false);
        setLegsPalette(false);
        setFeetPalette(false);
    };

    const handleOutfitInput = (e, cb) => {
        e.preventDefault();
        const textNumber = parseInt(e.target.value, 10);

        if (textNumber < 0 || textNumber > 132) return;
        closePalettes();
        if (isNaN(textNumber)) return cb(0);
        cb(textNumber);
    };

    const handleOutfitPalette = (e, val, cb) => {
        e.preventDefault();
        closePalettes();
        cb(val);
    };

    const handleMouseEnter = (e, val, cb) => {
        e.preventDefault();
        cb(val);
    };

    const handleMouseLeave = (e, cb) => {
        e.preventDefault();
        cb(false);
    };

    const handleChangeVocation = () => {
        let newVocation = vocation + 1;
        if (newVocation === 5) newVocation = 1;

        setVocation(newVocation);
        setLookType(lookTypeMap[sex][newVocation]);
    };

    const handleChangeSex = () => {
        const newSex = sex === 0 ? 1 : 0;
        setSex(newSex);
        setLookType(lookTypeMap[newSex][vocation]);
    };

    return (
        <div id='modal-createcharacter'>
            <div id='modal-container-createcharacter'>
                <div className='modal-panel-header'>
                    <h2 className='modal-panel-title'>Create Character</h2>
                    <button
                        type='button'
                        className='button modal-panel-close'
                        title='Close character creation'
                        onClick={closeModal}
                    >
                        Close
                    </button>
                </div>

                <form className='modal-form' onSubmit={handleSubmit}>

                    {errors?.accountid && errors.accountid.map((el, i) => <p key={i} className='modal-error-message'>{el}</p>)}
                    {errors?.name && errors.name.map((el, i) => <p key={i} className='modal-error-message'>{el}</p>)}
                    {errors?.sex && errors.sex.map((el, i) => <p key={i} className='modal-error-message'>{el}</p>)}
                    {errors?.vocation && errors.vocation.map((el, i) => <p key={i} className='modal-error-message'>{el}</p>)}
                    {errors?.looktype && errors.looktype.map((el, i) => <p key={i} className='modal-error-message'>{el}</p>)}
                    {errors?.lookhead && errors.lookhead.map((el, i) => <p key={i} className='modal-error-message'>{el}</p>)}
                    {errors?.lookbody && errors.lookbody.map((el, i) => <p key={i} className='modal-error-message'>{el}</p>)}
                    {errors?.looklegs && errors.looklegs.map((el, i) => <p key={i} className='modal-error-message'>{el}</p>)}
                    {errors?.lookfeet && errors.lookfeet.map((el, i) => <p key={i} className='modal-error-message'>{el}</p>)}
                    {errors?.msg && errors.msg.map((el, i) => <p key={i} className='modal-error-message'>{el}</p>)}

                    <label className="modal-label"> Name
                        <input className="modal-input" type="text" value={name} required
                            autoFocus
                            onKeyDown={(e) => handleButtonDown(e, buttonDisabled, handleSubmit)}
                            maxLength={60}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </label>
                    <label className="modal-label"> Vocation
                        <input className="modal-input create-character-cycle-input" type="text" required
                            value={vocationNames[vocation - 1]}
                            readOnly
                            onKeyDown={(e) => handleButtonDown(e, buttonDisabled, handleSubmit)}
                        />
                        <button className='create-character-cycle-button'
                            title='Change Vocation'
                            type='button'
                            onClick={() => handleChangeVocation()}
                        ><i className="fa-solid fa-arrows-rotate"/></button>
                    </label>
                    <label className="modal-label"> Sex
                        <input className="modal-input create-character-cycle-input" type="text" value={sex === 0 ? 'Female' : 'Male'}
                            onKeyDown={(e) => handleButtonDown(e, buttonDisabled, handleSubmit)}
                            onChange={(e) => {e.preventDefault(); return}}
                        />
                        <button className='create-character-cycle-button'
                            title='Change Sex'
                            type='button'
                            onClick={() => handleChangeSex()}
                        ><i className="fa-solid fa-arrows-rotate"/></button>
                    </label>

                    <div id='create-character-outfit-container'>
                        <div id='create-character-outfit-image'
                            title={`${outfits[looktype]} outfit`}
                        >
                            <img src={outfit} alt='Outfit'/>
                            <button
                                title='Turn Character'
                                type='button'
                                onClick={() => setDirection(direction === 4 ? 1 : direction + 1)}
                            ><i className="fa-solid fa-retweet"/></button>
                        </div>

                        <div id='create-character-outfit-inputs'
                            onMouseLeave={() => closePalettes(setHeadPalette, setBodyPalette, setLegsPalette, setFeetPalette)}
                        >
                            <label className="modal-label create-character-outfit-label"> Head<br></br>
                                <input className="modal-input create-character-outfit-input" type="text" value={lookhead}
                                    minLength={1}
                                    maxLength={3}
                                    onMouseEnter={() => {closePalettes(setHeadPalette, setBodyPalette, setLegsPalette, setFeetPalette); setHeadPalette(true)}}
                                    onClick={() => {closePalettes(setHeadPalette, setBodyPalette, setLegsPalette, setFeetPalette); setHeadPalette(!headPalette)}}
                                    onChange={(e) => handleOutfitInput(e, setHead)}
                                />
                                {headPalette && 
                                    <div className='create-character-color-palette-container'>
                                        <div className='create-character-color-palette'
                                            onMouseLeave={() => closePalettes(setHeadPalette, setBodyPalette, setLegsPalette, setFeetPalette)}
                                        >
                                            {paletteColors.map(el => 
                                                <button key={el} className='create-character-palette-button'
                                                    type='button'
                                                    onMouseEnter={(e) => handleMouseEnter(e, el, setTmpHead)}
                                                    onMouseLeave={(e) => handleMouseLeave(e, setTmpHead)}
                                                    onClick={(e) => handleOutfitPalette(e, el, setHead)}
                                                />
                                            )}
                                        </div>
                                    </div>
                                }
                            </label>

                            <label className="modal-label create-character-outfit-label"> Body<br></br>
                                <input className="modal-input create-character-outfit-input" type="text" value={lookbody}
                                    minLength={1}
                                    maxLength={3}
                                    onMouseEnter={() => {closePalettes(setHeadPalette, setBodyPalette, setLegsPalette, setFeetPalette); setBodyPalette(true)}}
                                    onClick={() => {closePalettes(setHeadPalette, setBodyPalette, setLegsPalette, setFeetPalette); setBodyPalette(!bodyPalette)}}
                                    onChange={(e) => handleOutfitInput(e, setBody)}
                                />
                                {bodyPalette && 
                                    <div className='create-character-color-palette-container'>
                                        <div className='create-character-color-palette'
                                            onMouseLeave={() => closePalettes(setHeadPalette, setBodyPalette, setLegsPalette, setFeetPalette)}
                                        >
                                            {paletteColors.map(el => 
                                                <button key={el} className='create-character-palette-button'
                                                    type='button'
                                                    onMouseEnter={(e) => handleMouseEnter(e, el, setTmpBody)}
                                                    onMouseLeave={(e) => handleMouseLeave(e, setTmpBody)}
                                                    onClick={(e) => handleOutfitPalette(e, el, setBody)}
                                                />
                                            )}
                                        </div>
                                    </div>
                                }
                            </label>

                            <label className="modal-label create-character-outfit-label"> Legs<br></br>
                                <input className="modal-input create-character-outfit-input" type="text" value={looklegs}
                                    minLength={1}
                                    maxLength={3}
                                    onMouseEnter={() => {closePalettes(setHeadPalette, setBodyPalette, setLegsPalette, setFeetPalette); setLegsPalette(true)}}
                                    onClick={() => {closePalettes(setHeadPalette, setBodyPalette, setLegsPalette, setFeetPalette); setLegsPalette(!legsPalette)}}
                                    onChange={(e) => handleOutfitInput(e, setLegs)}
                                />
                                {legsPalette && 
                                    <div className='create-character-color-palette-container'>
                                        <div className='create-character-color-palette'
                                            onMouseLeave={() => closePalettes(setHeadPalette, setBodyPalette, setLegsPalette, setFeetPalette)}
                                        >
                                            {paletteColors.map(el => 
                                                <button key={el} className='create-character-palette-button'
                                                    type='button'
                                                    onMouseEnter={(e) => handleMouseEnter(e, el, setTmpLegs)}
                                                    onMouseLeave={(e) => handleMouseLeave(e, setTmpLegs)}
                                                    onClick={(e) => handleOutfitPalette(e, el, setLegs)}
                                                />
                                            )}
                                        </div>
                                    </div>
                                }
                            </label>

                            <label className="modal-label create-character-outfit-label"> Feet<br></br>
                                <input className="modal-input create-character-outfit-input" type="text" value={lookfeet}
                                    minLength={1}
                                    maxLength={3}
                                    onMouseEnter={() => {closePalettes(setHeadPalette, setBodyPalette, setLegsPalette, setFeetPalette); setFeetPalette(true)}}
                                    onClick={() => {closePalettes(setHeadPalette, setBodyPalette, setLegsPalette, setFeetPalette); setFeetPalette(!feetPalette)}}
                                    onChange={(e) => handleOutfitInput(e, setFeet)}
                                />
                                {feetPalette && 
                                    <div className='create-character-color-palette-container'>
                                        <div className='create-character-color-palette'
                                            onMouseLeave={() => closePalettes(setHeadPalette, setBodyPalette, setLegsPalette, setFeetPalette)}
                                        >
                                            {paletteColors.map(el => 
                                                <button key={el} className='create-character-palette-button'
                                                    type='button'
                                                    onMouseEnter={(e) => handleMouseEnter(e, el, setTmpFeet)}
                                                    onMouseLeave={(e) => handleMouseLeave(e, setTmpFeet)}
                                                    onClick={(e) => handleOutfitPalette(e, el, setFeet)}
                                                />
                                            )}
                                        </div>
                                    </div>
                                }
                            </label>
                        </div>
                    </div>

                    <div id='create-character-buttons'>
                        <button className='create-character-create-button'
                            title={loading ? 'Loading please wait...' : 'Create Character'}
                            type='submit'
                        >Create</button>

                        <button className='create-character-exit-button'
                            title='Exit character creation'
                            type='button'
                            onClick={closeModal}
                        >Exit</button>
                    </div>

                </form>


            </div>
        </div>
    );
};

export default CreateCharacterModal;